import { z } from 'zod'

export const userId = z.uuid()
export type UserId = z.infer<typeof userId>

export const username = z
  .string()
  .min(2)
  .max(32)
  .regex(/^[a-zA-Z0-9_-]+$/, 'letters, numbers, underscore and hyphen only')

export const user = z.object({
  id: userId,
  username,
  rating: z.number().int(),
  ratingDeviation: z.number().int(),
  puzzlesAttempted: z.number().int().min(0),
  createdAt: z.date(),
})

export type User = z.infer<typeof user>

export const loginInput = z.object({
  username,
  password: z.string().min(1).max(256),
})

export type LoginInput = z.infer<typeof loginInput>
